import { render } from "./Warnings.vue?vue&type=template&id=e7ff54fc&scoped=true"
import script from "./Warnings.vue?vue&type=script&lang=js"
export * from "./Warnings.vue?vue&type=script&lang=js"

import "./Warnings.vue?vue&type=style&index=0&id=e7ff54fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7ff54fc"]])

export default __exports__